export enum GateActionEnum {
  AUTOMATIC_VEND = 'automatic',
  SUBSCRIPTION_VEND = 'subscriber',
  TEXT_TO_VEND = 'textToVend',
  TEXT_TO_PAY = 'textToPay',
  NESTED_ZONE_VEND = 'nestedZone',
  VALET_EXIT = 'valetExit',
  RESERVATION = 'reservation',
  PARKING_PASS = 'parkingPass',
}
